import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Navbar } from '../components/Navbar';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#030014]" data-testid="payment-cancel-page">
      <Navbar />
      <div className="pt-32 flex items-center justify-center px-4">
        <div className="admin-card p-8 max-w-md w-full text-center">
          <XCircle className="w-12 h-12 text-yellow-400 mx-auto mb-4" />
          <h1 className="text-xl font-bold mb-2">Payment Cancelled</h1>
          <p className="text-gray-400 text-sm mb-6">Your payment was cancelled. No charges were made.</p>
          <button onClick={() => navigate('/browse')}
            className="px-6 py-2.5 bg-[#8B5CF6] hover:bg-[#7C3AED] rounded-xl text-white font-medium transition-colors"
            data-testid="back-to-browse">
            Continue Browsing
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
